<div [formGroup]="group">
  <select [formControlName]="config.name" class="form-control">
    <option *ngIf="config.placeholder" value="" [disabled]="placeholderOnEmpty" [hidden]="placeholderOnEmpty">
      {{ config.placeholder }}
    </option>
    <option
      *ngFor="let opt of config.options"
      [value]="opt.value"
      [selected]="opt.selected || config.value === opt.value ? 'selected' : null"
    >
      {{ opt.text }}
    </option>
  </select>
  <i class="icon icon-ui-arrow--down"></i>
</div>
